// Genre ids reserved by the backend genre list (/client/genre/{lang}) for the
// two entries that are not real genres.
export const ALL_CHANNELS_GENRE_ID = 2;
export const FAVORITE_CHANNELS_GENRE_ID = 5;

// MW channels can belong to several genres. Legacy channel responses carry
// the same relationship as a single `genreId`.
export const filterChannelsByGenre = (channels, genre) => {
  if (!Array.isArray(channels)) {
    return [];
  }

  if (!genre || genre?.id === ALL_CHANNELS_GENRE_ID) {
    return channels;
  }

  if (genre?.id === FAVORITE_CHANNELS_GENRE_ID) {
    return channels.filter(
      (item) => item?.interactions?.includes("CHANNEL_FAV") ?? false
    );
  }

  return channels.filter(
    (item) =>
      genre.id === item?.genreId ||
      (Array.isArray(item?.genres) &&
        item.genres.some((entry) => entry?.id === genre.id))
  );
};
